export default __webpack_public_path__ + "static/media/techcamp_pic.0331f638.png";